<div class="dn-mobile db-tablet-up align-right">
  <fcom-button
    (click)="clicked.emit()"
    [theme]="ButtonTheme.SECONDARY"
    [size]="ButtonSize.R_MEDIUM"
    [text]="'actions.modify' | finLocalization"
    [aria]="{ label: label ? label : ('actions.modify' | finLocalization), role: 'button' }"
  >
  </fcom-button>
</div>
<div class="db-mobile dn-mobile-up">
  <fcom-button
    (click)="clicked.emit()"
    [theme]="ButtonTheme.SECONDARY"
    [size]="ButtonSize.R_MEDIUM"
    [mode]="ButtonMode.FILL"
    [text]="'actions.modify' | finLocalization"
    [aria]="{ label: label ? label : ('actions.modify' | finLocalization), role: 'button' }"
  >
  </fcom-button>
</div>
